import React from "react";
import styles from '../../css/Part13.module.css';

function PartTandC() {
  return (
    <section id="terms" className={styles.termsSection}>
        <h1>Terms and Conditions</h1>
      <div className={styles.header}>
        <p className={styles.modifiedDate}>Last modified: 11th November 2020</p>
        <p className={styles.text}>
          FoneApp provides <strong>INFORMATION</strong> services to users around the world.
        </p>
        <p className={styles.text}>
        When we say “FoneApp,” “our,” “we,” or “us,” we’re talking about FoneApp, ForestONE and/or MV Asia Sdn Bhd. 
        which is the operating company. Please read our Terms of Service so you understand what’s up with your use of FoneApp. 
        You agree to our Terms of Service (“Terms”) by installing, accessing, or using our apps, services, features, software, or website (together, “Services”).
        </p>
      </div>
      
      <div className={styles.section}>
        <div className={styles.sectionHeader}>
          REQUIRED USER INFORMATION
        </div>
        <div className={styles.sectionContent}>
          <p className={styles.text}>
          Registration. You must register for our Services using accurate data, provide your Full Name (In accordance to your NRIC), 
          Malaysian NRIC number, current mobile phone number, email, full address with postcode and, if you change any of these information, 
          update these information in our app or send an email to Support@forestone.com.my accordingly. Only Malaysian with valid Malaysian identification 
          (eg: Malaysian I/C, Malaysian Passport, etc) is allowed to register for a FoneApp account. You agree to receive text messages and phone calls 
          (from us or our third-party providers) with codes to register for our Services and/or for other purposes. You agree that FoneApp reserves the right 
          to request for proof of identity (eg. Malaysian I/C, Malaysian Passport, etc) for verification purposes at any time.
          </p>
        </div>
      </div>

      <div className={styles.section}>
        <div className={styles.sectionHeader}>
          ACCESS TO MOBILE PHONE LOCATION
        </div>
        <div className={styles.sectionContent}>
          <p className={styles.text}>
          You provide us access to your mobile phone and/or device location on a regular basis.
          </p>
        </div>
      </div>

      <div className={styles.section}>
        <div className={styles.sectionHeader}>
        Minimum Age Requirement
        </div>
        <div className={styles.sectionContent}>
          <p className={styles.text}>
          You must be at least 18 years old to use our Services. In addition to being of the minimum required age to use our Services under applicable law,
           if you are not old enough to have the authority to agree to our Terms in your country, your parent or guardian must agree to our Terms on your behalf.
          </p>
        </div>
      </div>

      <div className={styles.section}>
        <div className={styles.sectionHeader}>
        Installing Updates Automatically
        </div>
        <div className={styles.sectionContent}>
          <p className={styles.text}>
          Devices and Software. You must provide certain devices, software, and data connections to use our Services, which we otherwise do not supply. For as long as you use our Services, 
          you consent to downloading and installing updates to our Services, including automatically.
          </p>
        </div>
      </div>

      <div className={styles.section}>
        <div className={styles.sectionHeader}>
        Fees And Taxes
        </div>
        <div className={styles.sectionContent}>
          <p className={styles.text}>
          You are responsible for all carrier data plan and other fees and taxes associated with your use of our Services. We may charge you for our Services, including applicable taxes. 
          We may refuse or cancel orders. We do not provide refunds for our Services, except as required by law.
          </p>
        </div>
      </div>

      <div className={styles.section}>
        <div className={styles.sectionHeader}>
        Payment Of Our Services
        </div>
        <div className={styles.sectionContent}>
          <p className={styles.text}>
          In order to become a Premium user of FoneApp you have to pay a one time fee of Ringgit Malaysia three hundred ninety eight (RM398.00). Both Premium users and Free users hereby agree to the FoneApp Terms of Service. A person may only open one (1) Free membership user account. 
          However, a person may open unlimited number of Premium Membership user accounts.
          </p>
          <p mb-3 className={styles.text}>
          FoneApp will not be held liable for any wrongly entered or accidental payments or transactions made into FoneApp and you agree that FoneApp is not obligated to refund any of the payments made. In the event if any suspicious large amount of payments are made into FoneApp, 
          you agree that FoneApp may submit your particulars and information to the authorities under the suspicious transaction rule of the Anti Money Laundering Act.
          </p>
        </div>
      </div>


      <div className={styles.section}>
        <div className={styles.sectionHeader}>
        Privacy Policy And User Data
        </div>
        <div className={styles.sectionContent}>
          <p className={styles.text}>
          FoneApp cares about your privacy. FoneApp’s Privacy Policy describes our information practices, including the types of information we receive and collect from you and how we use and share this information.To view our Privacy Policy. You agree to our data practices, including the collection, use, processing, and sharing of your information as described in our Privacy Policy, as well as the transfer and processing of your information to Malaysia and other countries globally where we have or use facilities, service providers, or partners, regardless of where you use our Services. You acknowledge that the laws, 
          regulations, and standards of the country in which your information is stored or processed may be different from those of your own country.
          </p>
        </div>
      </div>

      <div className={styles.section}>
        <div className={styles.sectionHeader}>
        Acceptable Use Of Our Services
        </div>
        <div className={styles.sectionContent}>
          <p className={styles.text}>
          Our Terms and Policies. You must use our Services according to our Terms and posted policies. In the event if any suspected fraudulent activity is found which may cause harm or loss to FoneApp, you agree that FoneApp reserves the right to suspend or void all sales, or purchases, or services until further investigation and verification is conducted. You also agree that if any fraud or attempt to cheat FoneApp is discovered with proof, 
          FoneApp may file a police report on the aforesaid matter. If we disable your account for a violation of our Terms, you will not be able to create another account without our permission.
          </p>
          <p mb-3 className={styles.text}>
          <p mb-3 className={styles.text}>Rebate Coupon usage and T&C</p>
            1. Every FoneApp member can only get 1 Rebate Coupon per campaign, unless stated otherwise in the Rebate Coupon T&C.<br/>
            2. Every Rebate Coupon can only be used once, per member, per account.<br/>
            3. Any attempt to utilise the Rebate Coupon more than once, such attempts will not be honored.<br/>
            4. In case of any detected attempt of fraud or suspicious actions, FoneApp reserves the right to void or cancel the transaction.<br/>
          </p>
          <p mb-3 className={styles.text}>
          <p mb-3 className={styles.text}>Digital Voucher usage and T&C</p>
            1. Digital voucher (including but not limited to any discount provided by the e-voucher) is valid only up to the expiry date stated on the e-voucher.<br/>
            2. Digital voucher purchased are non-refundable and non-transferrable.
          </p>
        </div>
      </div>

      <div className={styles.section}>
        <div className={styles.sectionHeader}>
        Legal And Acceptable Use
        </div>
        <div className={styles.sectionContent}>
          <p className={styles.text}>
          You must access and use our Services only for legal, authorized, and acceptable purposes. You will not use (or assist others in using) our Services in ways that:
           (a) violate, misappropriate, or infringe the rights of FoneApp, our users, or others, including privacy, publicity, intellectual property, or other proprietary rights; 
           (b) are illegal, obscene, defamatory, threatening, intimidating, harassing, hateful, racially, or ethnically offensive, or instigate or encourage conduct that would be
            illegal, or otherwise inappropriate, including promoting violent crimes; (c) involve publishing falsehoods, misrepresentations, or misleading statements; 
            (d) impersonate someone; (e) involve sending illegal or impermissible communications, and the like; or (f) involve any non-personal use of our Services unless 
            otherwise authorized by us.
          </p>
        </div>
      </div>

      <div className={styles.section}>
        <div className={styles.sectionHeader}>
        Keeping Your Account Secure
        </div>
        <div className={styles.sectionContent}>
          <p className={styles.text}>
          You are responsible for keeping your device and your FoneApp account safe and secure, and you must notify us promptly of any unauthorized use or security breach of your 
          account or our Services
          </p>
        </div>
      </div>

      <div className={styles.section}>
        <div className={styles.sectionHeader}>
        Arbitration
        </div>
        <div className={styles.sectionContent}>
          <p className={styles.text}>
          FoneApp and you agree to resolve all disputes through binding individual arbitration, which means that you waive any right to have those disputes decided by a judge or jury, 
          and that you waive your right to participate in class actions, class arbitrations, or representative actions.
          </p>
        </div>
      </div>


      <div className={styles.section}>
        <div className={styles.sectionHeader}>
        Time Limit To Start Arbitration
        </div>
        <div className={styles.sectionContent}>
          <p className={styles.text}>
          We and you agree that for any Dispute we and you must commence an arbitration proceeding within sixty (60) days after the Dispute first arose; otherwise, such Dispute is permanently barred. 
          This means that if we or you do not commence an arbitration within sixty (60) days after the Dispute first arose, then the arbitration will be dismissed because it was started too late.
          </p>
        </div>
      </div>


      <div className={styles.section}>
        <div className={styles.sectionHeader}>
        Third-party services
        </div>
        <div className={styles.sectionContent}>
          <p className={styles.text}>
          Our Services may allow you to access, use, or interact with third-party websites, apps, content, and other products and services. Please note that when you use third-party services, 
          their own terms and privacy policies will govern your use of those services.
          </p>
        </div>
      </div>


      <div className={styles.section}>
        <div className={styles.sectionHeader}>
        Licenses – Who Owns User Data and/or Information
        </div>
        <div className={styles.sectionContent}>
          <p className={styles.text}>
          FoneApp becomes the owner and owns all of the information that you submit for your FoneApp account or through our Services. You must have the necessary rights to such information 
          that you submit for your FoneApp account or through our Services and the right to grant the rights and licenses in our Terms. FoneApp is allowed to store, use, transfer, sell, 
          assign and share all of the information that you submit for your FoneApp account or through our Services.
          </p>
        </div>
      </div>


      <div className={styles.section}>
        <div className={styles.sectionHeader}>
        FoneApp’s Rights
        </div>
        <div className={styles.sectionContent}>
          <p className={styles.text}>
          We own all copyrights, trademarks, domains, logos, trade dress, trade secrets, patents, and other intellectual property rights associated with our Services. You may not use our copyrights, 
          trademarks, domains, logos, trade dress, patents, and other intellectual property rights unless you have our express permission. You may use the trademarks of our 
          affiliated companies only with their permission.
          </p>
        </div>
      </div>


      <div className={styles.section}>
        <div className={styles.sectionHeader}>
        Your License to FoneApp
        </div>
        <div className={styles.sectionContent}>
          <p className={styles.text}>
          In order to operate and provide our Services, you grant FoneApp a worldwide, non-exclusive, royalty-free, sublicensable, and transferable license to use, 
          reproduce, distribute, create derivative works of, display, and perform the information (including the content) that you upload, submit, store, send, or 
          receive on or through our Services.
          </p>
        </div>
      </div>


      <div className={styles.section}>
        <div className={styles.sectionHeader}>
        FoneApp’s License to You
        </div>
        <div className={styles.sectionContent}>
          <p className={styles.text}>
          We grant you a limited, revocable, non-exclusive, non-sublicensable, and non-transferable license to use our Services, subject to and in accordance with our Terms. This license is for the sole purpose of enabling 
          you to use our Services, in the manner permitted by our Terms. No licenses or rights are granted to you by implication or otherwise, except for the licenses and rights 
          expressly granted to you.
          </p>
        </div>
      </div>


      <div className={styles.section}>
        <div className={styles.sectionHeader}>
        Reporting Third-Party Copyright, Trademark, And Other Intellectual Property Infringement
        </div>
        <div className={styles.sectionContent}>
          <p className={styles.text}>
          You are to report claims of third-party copyright, trademark, or other intellectual 
          property infringement as soon as you have discovered the said infringement. We may 
          terminate your FoneApp account if you repeatedly infringe the intellectual property rights of others.
          </p>
        </div>
      </div>


      <div className={styles.section}>
        <div className={styles.sectionHeader}>
        Disclaimers
        </div>
        <div className={styles.sectionContent}>
          <p className={styles.text}>
          YOU USE OUR SERVICES AT YOUR OWN RISK AND SUBJECT TO THE FOLLOWING DISCLAIMERS. WE ARE PROVIDING OUR SERVICES ON AN “AS IS” BASIS WITHOUT ANY EXPRESS OR IMPLIED WARRANTIES, 
          INCLUDING, BUT NOT LIMITED TO, WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE, NON-INFRINGEMENT, AND FREEDOM FROM COMPUTER VIRUS OR OTHER HARMFUL CODE. 
          WE DO NOT WARRANT THAT ANY INFORMATION PROVIDED BY US IS ACCURATE, COMPLETE, OR USEFUL, THAT OUR SERVICES WILL BE OPERATIONAL, ERROR FREE, SECURE, OR SAFE, OR THAT OUR SERVICES 
          WILL FUNCTION WITHOUT DISRUPTIONS, DELAYS, OR IMPERFECTIONS. WE DO NOT CONTROL, AND ARE NOT RESPONSIBLE FOR, CONTROLLING HOW OR WHEN OUR USERS USE OUR SERVICES OR THE FEATURES,
           SERVICES, AND INTERFACES OUR SERVICES PROVIDE. WE ARE NOT RESPONSIBLE FOR AND ARE NOT OBLIGATED TO CONTROL THE ACTIONS OR INFORMATION (INCLUDING CONTENT) OF OUR USERS OR OTHER
            THIRD PARTIES. YOU RELEASE US, OUR SUBSIDIARIES, AFFILIATES, AND OUR AND THEIR DIRECTORS, OFFICERS, EMPLOYEES, PARTNERS, AND AGENTS (TOGETHER, THE “FONEAPP PARTIES”) FROM ANY 
            CLAIM, COMPLAINT, CAUSE OF ACTION, CONTROVERSY, OR DISPUTE (TOGETHER, “CLAIM”) AND DAMAGES, KNOWN AND UNKNOWN, RELATING TO, ARISING OUT OF, OR IN ANY WAY CONNECTED WITH ANY 
            SUCH CLAIM YOU HAVE AGAINST ANY THIRD PARTIES. YOU WAIVE ANY RIGHTS YOU MAY HAVE UNDER THE MALAYSIAN FEDERAL CONSTITUTION, OR ANY OTHER SIMILAR APPLICABLE STATUTES OR LAW IN 
            MALAYSIA AND OF ANY OTHER JURISDICTION, WHICH SAYS THAT: A GENERAL RELEASE DOES NOT EXTEND TO CLAIMS WHICH THE CREDITOR DOES NOT KNOW OR SUSPECT TO EXIST IN HIS OR HER FAVOR 
            AT THE TIME OF EXECUTING THE RELEASE, WHICH IF KNOWN BY HIM OR HER MUST HAVE MATERIALLY AFFECTED HIS OR HER SETTLEMENT WITH THE DEBTOR.
          </p>
        </div>
      </div>


      <div className={styles.section}>
        <div className={styles.sectionHeader}>
        Limitation Of Liability
        </div>
        <div className={styles.sectionContent}>
          <p className={styles.text}>
          THE FONEAPP PARTIES WILL NOT BE LIABLE TO YOU FOR ANY LOST PROFITS OR CONSEQUENTIAL, SPECIAL, PUNITIVE, INDIRECT, OR INCIDENTAL DAMAGES RELATING TO, ARISING OUT OF, OR IN ANY WAY 
          IN CONNECTION WITH OUR TERMS, US, OR OUR SERVICES, EVEN IF THE FONEAPP PARTIES HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. OUR AGGREGATE LIABILITY RELATING TO, ARISING OUT 
          OF, OR IN ANY WAY IN CONNECTION WITH OUR TERMS, US, OR OUR SERVICES WILL NOT EXCEED THE GREATER OF ONE THOUSAND RINGGIT MALAYSIA (RM1,000.00). THE FOREGOING DISCLAIMER OF CERTAIN 
          DAMAGES AND LIMITATION OF LIABILITY WILL APPLY TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW. THE LAWS OF SOME COUNTRIES OR JURISDICTIONS MAY NOT ALLOW THE EXCLUSION OR 
          LIMITATION OF CERTAIN DAMAGES, SO SOME OR ALL OF THE EXCLUSIONS AND LIMITATIONS SET FORTH ABOVE MAY NOT APPLY TO YOU. NOTWITHSTANDING ANYTHING TO THE CONTRARY IN OUR TERMS, 
          IN SUCH CASES, THE LIABILITY OF THE FONEAPP PARTIES WILL BE LIMITED TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW.
          </p>
        </div>
      </div>


      <div className={styles.section}>
        <div className={styles.sectionHeader}>
        Indemnification
        </div>
        <div className={styles.sectionContent}>
          <p className={styles.text}>
          You agree to defend, indemnify, and hold harmless the FoneApp Parties from and against all liabilities, damages, losses, and expenses of any kind (including reasonable legal fees 
          and costs) relating to, arising out of, or in any way in connection with any of the following: (a) your access to or use of our Services, including information provided in connection 
          therewith; (b) your breach or alleged breach of our Terms; or (c) any misrepresentation made by you. You will cooperate as fully as required by us in the defense or settlement of 
          any Claim.
          </p>
        </div>
      </div>


      <div className={styles.section}>
        <div className={styles.sectionHeader}>
        Dispute Resolution
        </div>
        <div className={styles.sectionContent}>
          <p className={styles.text}>
          Forum and Venue. You agree that you and FoneApp will resolve any Claim relating to, arising out of, or in any way in connection with our Terms, us, or our Services 
          (each, a “Dispute,” and together, “Disputes”) exclusively in Malaysia, and you agree to submit to the personal jurisdiction of such courts for the purpose of litigating 
          all such Disputes. Without prejudice to the foregoing, you agree that, in our sole discretion, we may elect to resolve any Dispute we have with you in any competent court 
          in the country in which you reside that has jurisdiction over the Dispute.
          </p>
        </div>
      </div>


      <div className={styles.section}>
        <div className={styles.sectionHeader}>
        Governing Law
        </div>
        <div className={styles.sectionContent}>
          <p className={styles.text}>
          The laws of Malaysia govern our Terms, as well as any Disputes, whether in court or arbitration, which might arise between FoneApp and you, without regard to conflict of law provisions.
          </p>
        </div>
      </div>


      <div className={styles.section}>
        <div className={styles.sectionHeader}>
        Availability and Termination of Our Services
        </div>
        <div className={styles.sectionContent}>
          <p className={styles.text}>
          Regardless of any provisions in these Terms and Conditions, FoneApp may modify, suspend, or terminate your access to or use of our Services anytime for any reasons immediately, without providing any reason or notice to you.
          </p>
          <p mb-3 className={styles.text}>
                1. If your account isn’t active within the span of 12 months, it includes that FoneApp will void all FoneVoucher (balance), FonePoint, sales, or purchases, or Services.
                2. If you violate the letter or spirit of our terms or create harm, risk, or possible legal exposure for us, our users, or others <br/>
                3. If FoneApp believes there is dishonesty, suspected fraud, abuse, misuse, illegality, criminal activity, or misrepresentation in the management of your Account or the use of the Services;<br/>
                4. If you are in violation of any laws, statutes, regulations, by-laws, or rules imposed by any regulatory body or government agency;<br/>
                5. If you have submitted false documents or provided false information during your application for the Service;<br/>
                6. If you have been blacklisted by any financial institution, licensed bank, or e-money issuer in Malaysia or abroad;<br/>
                7. If you are included on our internal watch lists;<br/>
                8. If your FoneApp Account or activities have been flagged for money laundering, terrorism financing, fraud, illegal, or suspicious activities; and/or<br/>
                9. If you fail to provide any additional information requested by FoneApp from time to time.<br/>
                10. If FoneApp terminates or suspends the Service or any part of it as stated in <strong>“Availability and Termination of Our Services”</strong>, FoneApp is not required to refund the <strong>Available Balance</strong> until and unless clearance has been obtained from the relevant authorities, if applicable.
          </p>
          <p mb-3 className={styles.text}>
          The following provisions will be archived upon any termination of your relationship with FoneApp: “Licenses,” “Disclaimers,” “Limitation of Liability,” “Indemnification,” 
          “Dispute Resolution,” “Availability and Termination of our Services,” and “Other.”
          </p>
        </div>
      </div>


      <div className={styles.section}>
        <div className={styles.sectionHeader}>
        Other
        </div>
        <div className={styles.sectionContent}>
          <p className={styles.text}>
          Unless a mutually executed agreement between you and us states otherwise, our Terms make up the entire agreement between you and us regarding FoneApp and our Services, and supersede any prior agreements.
          </p>
          <p mb-3 className={styles.text}>
          We may ask you to agree to additional terms for certain of our Services in the future, which will govern to the extent there is a conflict between our Terms and such additional terms.
          </p>
          <p mb-3 className={styles.text}>
          Our Services are not intended for distribution to or use in any country where such distribution or use would violate local law or would subject us to any regulations in another country. We reserve the right to limit our Services in any country.
          </p>
          <p mb-3 className={styles.text}>
          You will comply with all applicable Malaysian export control and trade sanctions laws (“Export Laws”). You will not, directly or indirectly, export, re-export, provide, 
          or otherwise transfer our Services: (a) to any individual, entity, or country prohibited by Export Laws; (b) to anyone on Malaysian government restricted parties lists; 
          or (c) for any purpose prohibited by Export Laws, including but not limited to applications without the required government authorizations. You will not use or download 
          our Services if you are located in a restricted country, if you are currently listed on any Malaysian restricted parties list, or for any purpose prohibited by Export Laws, 
          and you will not disguise your location through IP proxying or other methods.
          </p>
          <p mb-3 className={styles.text}>
          Our Terms are written solely in English.
          </p>
          <p mb-3 className={styles.text}>
          Any amendment to or waiver of our Terms requires our express consent.
          </p>
          <p mb-3 className={styles.text}>
          We may amend or update these Terms. We will provide you notice of amendments to our Terms, as appropriate, and update the “Last Modified” date at the top of our Terms. Your continued use of our Services confirms your acceptance of our Terms, as amended. 
          If you do not agree to our Terms, as amended, you must stop using our Services. Please review our Terms from time to time.
          </p>
          <p mb-3 className={styles.text}>
          All of our rights and obligations under our Terms are freely assignable by us to any of our affiliates or in connection with a merger, 
          acquisition, restructuring, or sale of assets, or by operation of law or otherwise, and we may transfer your information to any of our affiliates, successor entities, or new owner.
          </p>
          <p mb-3 className={styles.text}>
          You will not transfer any of your rights or obligations under our Terms to anyone else without our prior written consent.
          </p>
          <p mb-3 className={styles.text}>
          Nothing in our Terms will prevent us from complying with the law.
          </p>
          <p mb-3 className={styles.text}>
          Except as contemplated herein, our Terms do not give any third-party beneficiary rights.
          </p>
          <p mb-3 className={styles.text}>
          If we fail to enforce any of our Terms, it will not be considered a waiver.
          </p>
          <p mb-3 className={styles.text}>
          If any provision of these Terms is deemed unlawful, void, or for any reason unenforceable, then that provision shall be deemed severable from our Terms and shall not affect the validity and enforceability of the remaining provisions.
          </p>
          <p mb-3 className={styles.text}>
          We always appreciate your feedback or other suggestions about FoneApp and our Services, but you understand that we may use your feedback or suggestions without any obligation to compensate you for them (just as you have no obligation to offer them).
          </p>
        </div>
      </div>


      <div className={styles.section}>
        <div className={styles.sectionHeader}>
        Class action
        </div>
        <div className={styles.sectionContent}>
          <p className={styles.text}>
          No Class Actions, Class Arbitrations, or Representative Actions for FoneApp Users. We and you each agree that if you are a FoneApp user, each of we and you may bring Disputes against the other only on its or your own behalf, and not on behalf of any other person or entity, or any class of people. We and you each agree not to participate in a class action, a class-wide arbitration, 
          Disputes brought in a private attorney general or representative capacity, or consolidated Disputes involving any other person or entity in connection with any Dispute.
          </p>
        </div>
      </div>

      <div className={styles.section}>
        <div className={styles.sectionHeader}>
        Updates To Our Terms of Service
        </div>
        <div className={styles.sectionContent}>
          <p className={styles.text}>
          We may amend or update our Terms of Service. All latest updated versions shall be shown in the “Last Modified” date at the top of this Terms of Service.
          Your continued use of our Services confirms your acceptance of our Terms of Service, as amended. If you do not agree to our Terms of Service, as amended,
           you must stop using our Services. Please review our Terms of Service from time to time.
          </p>
        </div>
      </div>


      {/* Repeat for other sections */}
    </section>
  );
}

export default PartTandC;
